










































import AdUnit from "@/models/adUnit";
import Campaign, { LineItem } from "@/models/campaign";
import { DefinitionList } from "@/models/definition";
import DefinitionValue from "@/models/definitionValue";
import { QueryParams } from "@/models/general";
import Setting from "@/models/setting";
import Site from "@/models/site";
import User from "@/models/user";
import i18n from "@/plugins/i18n";
import CampaignsAPI from "@/services/campaigns";
import SettingsAPI from "@/services/settings";
import UsersAPI from "@/services/users";
import { LayoutModule } from "@/store/layout";
import moment from "moment";
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import ChangeLogEntry from "./ChangeLogEntry.vue";

@Component({
  components: {
    ChangeLogEntry,
  },
})
export default class CampaignChangeLog extends Vue {
  @Prop({ default: null }) campaign!: Campaign;
  @Prop({ default: () => [] }) sites!: Site[];
  @Prop({ default: () => [] }) definitions!: DefinitionList[];
  @Prop({ default: () => [] }) adUnits!: AdUnit[];

  changeLogs = [];
  invalidKeys = [
    "updatedAt",
    "Id",
    "targetUrlHistory",
    "bitlyHistory",
    "bitly",
    "contentType",
    "createdAt",
    "userId",
    "discount",
  ];
  settings: Setting | null = null;

  users: User[] = [];

  created(): void {
    this.getLogs();
    this.getUsers();
    this.getSettings();
  }

  get loading(): boolean {
    return LayoutModule.loaderIsVisible;
  }

  async getSettings(): Promise<void> {
    const s = await SettingsAPI.getSettings();

    this.settings = s;
  }

  async getUsers(): Promise<void> {
    const params: QueryParams = {
      page: {
        number: 1,
        size: -1,
      },
    };

    const r = await UsersAPI.getUsers(params);
    this.users = r.data;
  }

  async getLogs(): Promise<void> {
    const r = await CampaignsAPI.logs(this.campaign?.id as string);
    console.log(r.data);

    this.changeLogs = r.data;
  }

  formatTimeStamp(timestamp: string): string {
    return moment(timestamp).format("DD-MM-yyyy").toString();
  }

  emptyChangelog(changeLog: any): boolean {
    const keys = Object.keys(changeLog.modifications);
    const BreakException = {};
    let empty = true;

    if (changeLog.operation === "delete") return false;

    try {
      keys.forEach((key) => {
        if (this.validKey(key)) throw BreakException;
      });
    } catch (e) {
      empty = false;
    }

    return empty;
  }

  validKey(key: string): boolean {
    return !this.invalidKeys.includes(key);
  }

  getUserComposeName(id: string): string {
    const user = this.users.find((i) => i.id === id);
    return user ? `${user.name} ${user.familyName}` : "";
  }

  composeChangeDate(changeLog: any): string {
    try {
      return this.formatTimeStamp(changeLog.modifications.updatedAt[1]);
    } catch (e) {
      return this.formatTimeStamp(changeLog.createdAt);
    }
  }
}
